export default __webpack_public_path__ + "static/media/tick-blue.7d246c85.svg";